import * as React from "react";
import { Grid, Typography } from "@mui/material";
import logo from "../../assets/FERROEXPRESO.svg";

const Politica = () => {
  return (
    <React.Fragment>
      <Grid
        container
        spacing={0}
        direction="column"
        sx={{
          justify: "center",
          alignItems: "center",
          p: 3,
        }}
      >
        <Grid size={6}>
          <center>
            <img src={logo} width={"50%"} alt="FerroExpreso Pampeano" />
          </center>
          <br />
          <br />
          <Typography>
            FEPSA no recoge ning&uacute;n dato personal de los usuarios.
          </Typography>
          <Typography>FEPSA no registra direcciones IP.</Typography>
          <Typography>
            FEPSA no accede a los datos de contactos del dispositivo.
          </Typography>
          <Typography>
            FEPSA no accede a las cuentas de correos de los usuarios.
          </Typography>
          <Typography>
            FEPSA no guarda datos relativos al dispositivo.
          </Typography>
          <Typography>
            FEPSA, no Google, es el &uacute;nico responsable del contenido de
            las aplicaciones de FEPSA.
          </Typography>
          <Typography>
            FEPSA, no Google, ofrece soporte t&eacute;cnico a trav&eacute;s del
            correo fepsadevs@gmail.com
          </Typography>
          <br />
          <Typography>
            Para m&aacute;s informaci&oacute;n sobre la presente pol&iacute;tica
            de privacidad puede dirigirse a fepsadevs@gmail.com
          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default Politica;
